export default function PageHeader({ kicker, code, title, lead, eyebrow }) {
  return (
    <section
      data-testid="page-header"
      className="relative border-b border-[var(--ri-ink)] bg-[var(--ri-bg)] grid-bg overflow-hidden"
    >
      <div className="ri-container pt-14 pb-16 md:pt-20 md:pb-24 relative">
        <div className="flex flex-wrap items-center gap-3 mb-6">
          {eyebrow && <span className="ri-tag ri-tag--orange">{eyebrow}</span>}
          <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--ri-muted)]">
            {code} · {kicker}
          </span>
        </div>
        <h1 className="font-display text-[clamp(2.4rem,6.5vw,6rem)] tracking-tighter leading-[0.95]">
          {title}
        </h1>
        {lead && (
          <p className="mt-6 max-w-2xl text-[var(--ri-muted)] text-lg leading-relaxed">
            {lead}
          </p>
        )}
      </div>
    </section>
  );
}
